import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useState ,useEffect } from 'react'
import "../../MainCSS.css";
import axios from 'axios';
import {   DieCategoryMasterGet, DieSubCategoryMasterDelete, DieSubCategoryMasterGet, DieSubCategoryMasterSave, DieSubCategoryMasterUpdate } from '../../../AllAPI/MasterAPI/DiesMasterApi';
import { toast } from 'react-toastify';
import "aos/dist/aos.css";


const DieSubCategoryMaster = () => {

    const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };



   const [errors, setErrors] = useState({
       dieCategory: "",
       description: "",
   subDieCategory:"",
     });
   
     const [pageSize, setPageSize] = useState(10);
     const [filteredData, setFilteredData] = useState([]);
     const [currentPage, setCurrentPage] = useState(1);
     const [totalEntries, setTotalEntries] = useState(0);
   
     const [subDieCategoryId, setDieCategoryId] = useState("");
     const [dieCategory, setDieCategory] = useState("");
     const [description, setDescription] = useState("");
     const [subDieCategory, setSubDieCategory] = useState("");

     const [allSubDieCategory, setAllSubDieCategory] = useState([]);

     const [allDieCategory, setAllDieCategory] = useState([]);
     const [submitButton, setSubmitButton] = useState(true);
     const [updateButton, setUpdateButton] = useState(false);
   
     //======Search data from table===============
     const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
    
      const filtered = allSubDieCategory.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );
    
      setFilteredData(filtered);
      setTotalEntries(filtered.length);
      setCurrentPage(1);
    };
  
     //==========Pagination=======================
     const handlePageSizeChange = (value) => {
       setPageSize(value);
     };
      // ==============Get table data================
     let isSubDieCategoryMasterFetched = false;
     useEffect(() => {
       if (isSubDieCategoryMasterFetched) return;
           fetchSubDieCategoryMaster();
           fetchDieCategoryMaster();
       isSubDieCategoryMasterFetched = true;
     }, []);
   
     let isError = false;
   
     const fetchSubDieCategoryMaster = async () => {
       try {
         const response = await axios.get(DieSubCategoryMasterGet ,commonHeaders);
       if (response.data && response.data.length > 0) {
           setAllSubDieCategory(response.data);
           setFilteredData(response.data); // Set initial filtered data as the fetched data
           setTotalEntries(response.data.length); // Set the total number of entries
         }
           else{
                   toast.warn("Data is not available !!");
                   setAllSubDieCategory([]);
                   setFilteredData([]);
                   setTotalEntries([]);
         
                 }
       } catch (error) {
         if (!isError) {
           console.error("Error fetching Sub Die Category Master data:", error);
           toast.error("Failed to fetch Sub Die Category Master data");
           isError = true; // Set the flag to prevent double toast
         }
       }
     };
     const fetchDieCategoryMaster = async () => {
      try {
        const response = await axios.get(DieCategoryMasterGet,commonHeaders);
        if (response.data !== null) {
          setAllDieCategory(response.data);
        
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Die Category Master data:", error);
          toast.error("Failed to fetch Die Category Master data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
    
   
     const columns = [
       {
         title: "Sr.No.",
         dataIndex: "",
         key: "index",
         render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
       },
 
       {
         title:"Main Category Name",
         dataIndex: "dieCategoryName",
         key: "dieCategoryName",
             sorter: (a, b) => a.dieCategoryName.localeCompare(b.dieCategoryName),
       },
       {
        title:" Sub Category Name",
        dataIndex: "dieSubCategoryName",
        key: "dieSubCategoryName",
            sorter: (a, b) => a.dieSubCategoryName.localeCompare(b.dieSubCategoryName),
      },
       {
         title: "Description",
         dataIndex: "description",
         key: "description",
             sorter: (a, b) => a.description.localeCompare(b.description),
       },
    
       {
         title: "Actions",
         key: "actions",
         render: (text, record) => (
           <div>
             <span
               type="submit"
               style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
               onClick={() => handleEditDataButton(record)}
             >
               <i class="fa-solid fa-pen-to-square"></i>
             </span>
             <span
               type="submit"
               style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
               onClick={() => handleDeleteData(record)}
             >
               <i class="fa-solid fa-trash"></i>
             </span>
           </div>
         ),
       },
     ];
   
     const components = {
       header: {
         cell: ({ children, ...restProps }) => (
           <th
             {...restProps}
             style={{
               backgroundColor: "#023e7d",
               color: "#fff",
               padding: "10px",
               fontSize: "15px",
               borderRadius: "0px",
             }}
           >
             {children}
           </th>
         ),
       },
       body: {
         row: ({ children, ...restProps }) => (
           <tr
             {...restProps}
             style={{
               backgroundColor: "#f0f7fd",
             }}
           >
             {children}
           </tr>
         ),
         cell: ({ children, ...restProps }) => (
           <td
             {...restProps}
             style={{
               padding: "8px",
                fontSize: "15px",
             }}
           >
             {children}
           </td>
         ),
       },
     };
        // ========Submit data to table==============
        const handleSubmit = async () => {
          let isValid = true;
          const errorObj = {};
      
          if (!dieCategory || (typeof dieCategory === 'string' && !dieCategory.trim())) {
            isValid = false;
            errorObj.dieCategory = "Die Category Name is required *";
          }
          
          if (!subDieCategory.trim()) {
            isValid = false;
            errorObj.subDieCategory = " Sub Die Category Name is required *";
          }
          
          if (!description.trim()) {
            isValid = false;
            errorObj.description = "Description is required *";
          }
      
      
          setErrors(errorObj); // Set error messages
      
          if (!isValid) return;
      
          const bodyData = {
        
            description:description,
            dieCategoryId: dieCategory,
            dieSubCategoryName:subDieCategory,          
           
          };
      
          try {
            const response = await axios.post(DieSubCategoryMasterSave, bodyData ,commonHeaders);
      
            if (response.data === "CREATED") {
              toast.success(" Sub Category  added successfully!");
              fetchSubDieCategoryMaster();
              handleCancel();
            } else if (response.data === "ALREADYEXISTED") {
              toast.warn("Sub Category  already exist!");
              //handleCancel();
            }
          } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while submitting data");
          }
        };
    //==================== Handle Cancel button =====================
        const handleCancel = () => {
          setUpdateButton(false);
          setSubmitButton(true);
          setDescription("");
          setDieCategory("");
          setSubDieCategory("");
          setErrors("");
        };
      // ========Update data from table============
      const handleEditDataButton = (item) => {
        setUpdateButton(true);
        setSubmitButton(false);
        window.scrollTo(0, 0);
        setDieCategory(item.dieCategoryId);
        setDescription(item.description);
        setSubDieCategory(item.dieSubCategoryName);
        setDieCategoryId(item.id);
      };
      const handleUpdate = async () => {
        if (!dieCategory) {
          toast.warn("Please select a Category!");
          return;
        }
        if (!subDieCategory) {
          toast.warn("Please enter a Sub Category!");
          return;
        }
        if (!description) {
          toast.warn("Please enter Description!");
          return;
        }
    
    
       
        const bodyData = {
          id:subDieCategoryId,
          dieCategoryId: dieCategory,
          dieSubCategoryName:subDieCategory,
          description:description,
    
        };
    
        try {
         const response = await axios.put(DieSubCategoryMasterUpdate, bodyData ,commonHeaders);
           
          if (response.data === "UPDATED") {
            toast.success("Sub Category  updated successfully!");
            fetchSubDieCategoryMaster();
            handleCancel();
          } else if (response.data === "ALREADYEXISTED") {
            toast.warn(" Sub Category  already exist!");
            //handleCancel();
          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while updating data");
        }
      };
      //============================== Delete data from table ======================================
      const handleDeleteData = async (item) => {
        const confirmDelete = window.confirm(
          `Are you sure you want to delete the Sub Category  "${item.dieSubCategoryName}"?`
        );
        if (!confirmDelete) return;
    
        try {
          const response = await axios.delete(
            `${DieSubCategoryMasterDelete}?id=${item.id}`,commonHeaders
          );
          if (response.data === "DELETED") {
            toast.success("Sub Category deleted successfully!");
            fetchSubDieCategoryMaster();
            handleCancel();
          }
        } catch (error) {
          console.error("Error during delete operation:", error);
          toast.error("Error occurred while deleting ");
        }
      };
   return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">


     <div className="p-0 m-0">
           <div className="row px-md-5 mt-3 p-2 ">
   
   <div className="row p-0 m-0">
   <div className="col-12 col-lg-4"></div>
   <div className="col-12 col-lg-4">
   <div className="row p-0 m-0">
           
      
           <div className="col-12 py-1">
             <label className="labels"> Main Category</label>
             <Select
               value={dieCategory}
               onChange={(value) => setDieCategory(value)}
               placeholder="Select Category"
               style={{ width: '100%' }}
                 showSearch
                optionFilterProp="children"

             >
              {allDieCategory.map((category)=>(
                <Option key={category.id} value={category.id}>
                  {category.dieCategoryName}
                </Option>
              ))

              }
             </Select>
             {errors.dieCategory && <div className="errorField">{errors.dieCategory}</div>}
           </div>
         <div className="col-12 py-1">
                  <label className="labels"> Sub Category Name</label>
                  <Input
                    value={subDieCategory}
                    onChange={(e) => setSubDieCategory(e.target.value)}
                    placeholder="Enter Sub Die Category"
                    style={{ width: '100%' }}
                    maxLength="250"
                  />
                  {errors.subDieCategory && <div className="errorField">{errors.subDieCategory}</div>}
                </div>

                
           <div className="col-12 py-1">
             <label className="labels">Description</label>
             <Input.TextArea
               value={description}
               maxLength="250"
               onChange={(e) => setDescription(e.target.value)}
               placeholder="Enter description"
               style={{ width: '100%' }}
             />
             {errors.description && <div className="errorField">{errors.description}</div>}
           </div>
       </div>
       </div>
       </div>
           
               <div className="col-12 text-center pt-3">
                 <Button
                   type="submit"
                   className="CancelBtn mx-1"
                    onClick={handleCancel}
                 >
                   Cancel
                 </Button>
                 {submitButton && (
                   <Button
                     type="submit"
                     className="SubmitBtn mx-1"
                      onClick={handleSubmit}
                   >
                     Submit
                   </Button>
                 )}
                 {updateButton && (
                   <Button
                     type="submit"
                     className="UpdateBtn mx-1"
                      onClick={handleUpdate}
                   >
                     Update
                   </Button>
                 )}
               </div>
       
          
       
         <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div></div>
       
         {/*================ Table =========================*/}
         <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
           <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
             <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
               <div>
                 <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                 <Select
                   defaultValue={pageSize}
                   onChange={handlePageSizeChange}
                   style={{ width: 120, textAlign: "center" }}
                 >
                   <Option value={10}>10</Option>
                   <Option value={20}>20</Option>
                   <Option value={30}>30</Option>
                 </Select>
               </div>
       
               <div className="pt-4 pt-md-0">
                 <Input.Search
                   placeholder="Search"
                    onChange={(e) => handleSearch(e.target.value)}
                   style={{ width: 200, marginBottom: 16 }}
                 />
               </div>
             </div>
       
             <div style={{ backgroundColor: "white" }}>
               <Table
                 bordered
                 style={{ padding: "0px 20px", overflowX: "auto" }}
                 columns={columns}
                 dataSource={filteredData}
                 pagination={{
                   pageSize: pageSize,
                   total: totalEntries,
                   showTotal: (total, range) =>
                     `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                   current: currentPage,
                   onChange: (page) => setCurrentPage(page),
                 }}
                 showSorterTooltip={false}
                 rowKey={(record) => record.id}
                 components={components}
               />
             </div>
           </div>
         </div>
       </div>
       </div>
       </div>
       </div>
       )
}

export default DieSubCategoryMaster